import React from "react";
import "./../styles/Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <p>&copy; {currentYear} Proyecto Chicas Rosas</p>
        <ul className="footer-links">
          {/* <li>
            <a href="#privacy">Política de Privacidad</a>
          </li>
          <li>
            <a href="#terms">Términos y Condiciones</a>
          </li> */}
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
